var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.600098C2.81333 0.600098 0.220001 3.19343 0.220001 6.3801C0.220001 9.56676 2.81333 12.1668 6 12.1668C9.18667 12.1668 11.78 9.57343 11.78 6.38676C11.78 3.2001 9.18667 0.600098 6 0.600098ZM6.5 6.16676C6.5 6.4401 6.27333 6.66676 6 6.66676C5.72667 6.66676 5.5 6.4401 5.5 6.16676V2.83343C5.5 2.5601 5.72667 2.33343 6 2.33343C6.27333 2.33343 6.5 2.5601 6.5 2.83343V6.16676Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.ff23f4e2321ed0f80fdb3b9c85cd8b66.svg";
export { ForwardRef as ReactComponent };